module.exports = __webpack_public_path__ + "img/img_m&a_01.c06130b9.png";